import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import axios from "axios";
import toast from "react-hot-toast";

const CompanyMasterList = () => {
    const navigate = useNavigate();

    const [companyList, setCompanyList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchCompany, setSearchCompany] = useState("");

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteCompanyId, setDeleteCompanyId] = useState(null);

    const openDeleteModal = (companyId) => {
        setDeleteCompanyId(companyId);
        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setShowDeleteModal(false);
        setDeleteCompanyId(null);
    };

    // ================= FETCH COMPANIES =================
    const fetchCompanies = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("token");

            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/trading-partner?page=0&size=100`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log("Company List => ", response.data);

            setCompanyList(response?.data?.content || []);
        } catch (error) {
            console.error("Fetch Company Error => ", error);
            toast.error("Failed To Fetch Companies");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteCompany = async (companyId) => {
        try {
            const token = localStorage.getItem("token");

            await axios.delete(
                `${process.env.REACT_APP_BACKEND_URL}/trading-partner/${companyId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setCompanyList((prev) =>
                prev.filter(
                    (company) => company.companyId !== companyId
                )
            );

            toast.success("Company Deleted Successfully");
            closeDeleteModal();
        } catch (error) {
            console.error(error);
            toast.error("Failed To Delete Company");
        }
    };

    useEffect(() => {
        fetchCompanies();
    }, []);

    // ================= SEARCH =================
    const filteredCompanies = companyList.filter((company) =>
        (
            company?.organizationName ||
            `${company?.firstName || ""} ${company?.lastName || ""}`
        )
            .toLowerCase()
            .includes(searchCompany.toLowerCase())
    );

    return (
        <Layout>
            <div className="backgound-main-content p-4">
                <div className="container-fluid">
                    {/* Header */}
                    <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                        <h3 className="mb-0 fw-bold">Company Master List</h3>

                        <button
                            className="btn btn-primary"
                            onClick={() => navigate("/create-company-master")}
                        >
                            Add Company
                        </button>
                    </div>

                    {/* Search */}
                    <div className="row mb-4">
                        <div className="search-bar">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search Company Name"
                                value={searchCompany}
                                onChange={(e) => setSearchCompany(e.target.value)}
                            />

                            <Icon
                                icon="iconamoon:search"
                                width="20"
                                height="20"
                                color="rgba(0, 175, 239, 1)"
                            />
                        </div>
                    </div>

                    {/* Table */}
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover align-middle">
                            <thead className="table-light">
                                <tr>
                                    <th>Sr No</th>
                                    <th>Company Name</th>
                                    <th>GST Number</th>
                                    <th>Email</th>
                                    <th>Mobile Number</th>
                                    <th>City</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="8" className="text-center">
                                            Loading...
                                        </td>
                                    </tr>
                                ) : filteredCompanies.length > 0 ? (
                                    filteredCompanies.map((company, index) => (
                                        <tr key={company.tradingPartnerId}>
                                            <td>{index + 1}</td>

                                            <td>
                                                {company.organizationName ||
                                                    `${company.firstName || ""} ${company.lastName || ""
                                                    }`}
                                            </td>

                                            <td>{company.gstNumber || "-"}</td>

                                            <td>{company.email || "-"}</td>

                                            <td>{company.mobileNumber || "-"}</td>

                                            <td>{company?.address?.city || "-"}</td>

                                            <td>
                                                <span
                                                    className={`badge ${company.active
                                                        ? "bg-success"
                                                        : "bg-danger"
                                                        }`}
                                                >
                                                    {company.active ? "Active" : "Inactive"}
                                                </span>
                                            </td>

                                            <td>
                                                <div className="d-flex gap-2">
                                                    {/* View */}
                                                    <Icon
                                                        icon="hugeicons:view"
                                                        style={{
                                                            color: "#00AFEF",
                                                            fontSize: "18px",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                            navigate(
                                                                `/company-masterview/${company.tradingPartnerId}`
                                                            )
                                                        }
                                                    />

                                                    {/* Edit */}
                                                    <Icon
                                                        icon="mdi:edit"
                                                        style={{
                                                            color: "#00AFEF",
                                                            fontSize: "18px",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                            navigate(`/create-company-master`, {
                                                                state: {
                                                                    companyId: company.tradingPartnerId,
                                                                    isEdit: true,
                                                                },
                                                            })
                                                        }
                                                    />
                                                    <Icon
                                                        icon="material-symbols:delete-outline"
                                                        width="20"
                                                        className="cursor-pointer"
                                                        style={{
                                                            color: "#DD0000",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                            openDeleteModal(company.tradingPartnerId)
                                                        }
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center">
                                            No Company Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {/* Delete Confirmation Modal */}
            <div
                className={`modal fade ${showDeleteModal ? "show d-block" : ""
                    }`}
                tabIndex="-1"
                style={{
                    backgroundColor: "rgba(0,0,0,0.5)",
                }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div
                        className="modal-content border-0"
                        style={{
                            borderRadius: "18px",
                            padding: "20px",
                        }}
                    >
                        <div className="modal-body text-center">

                            {/* Delete Icon */}
                            <div
                                className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                                style={{
                                    width: "60px",
                                    height: "60px",
                                    borderRadius: "50%",
                                    background: "#FFEAEA",
                                }}
                            >
                                <Icon
                                    icon="material-symbols:delete-outline-rounded"
                                    width="32"
                                    height="32"
                                    color="#E53935"
                                />
                            </div>

                            {/* Title */}
                            <h2
                                style={{
                                    fontWeight: "700",
                                    marginBottom: "10px",
                                }}
                            >
                                Confirm Delete
                            </h2>

                            {/* Message */}
                            <p
                                style={{
                                    color: "#666",
                                    fontSize: "16px",
                                    marginBottom: "25px",
                                }}
                            >
                                Are you sure you want to delete this company?
                            </p>

                            {/* Buttons */}
                            <div className="d-flex justify-content-center gap-3">
                                <button
                                    className="btn btn-light px-4"
                                    onClick={closeDeleteModal}
                                    style={{
                                        borderRadius: "10px",
                                        fontWeight: "500",
                                    }}
                                >
                                    Cancel
                                </button>

                                <button
                                    className="btn btn-danger px-4"
                                    style={{
                                        borderRadius: "10px",
                                        fontWeight: "600",
                                    }}
                                    onClick={() =>
                                        handleDeleteCompany(deleteCompanyId)
                                    }
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default CompanyMasterList;